
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty, omit } from "lodash";
import { Button, Input, Typography } from "antd";
import { Select } from "components";
import { getAllAppConfigurations, getSelectedAppConfiguration, restoreConfig, updateAppConfig } from "store/adminPanel/actions";
import { type } from "@testing-library/user-event/dist/type";
import { ReactComponent as WarningRed } from 'assets/icons/warning-red.svg';
import { Modal } from 'components';

const Templates = () => {
  const dispatch = useDispatch();
  const config = useSelector(state => state.forms.appConfig);
  const configError = useSelector(state => state.forms.appConfigError);
  const allConfigs = useSelector(state => state.adminPanel.appConfigs);
  const selectedConfigValue = useSelector(state => state.adminPanel.selectedConfig?.value);
  const selectedConfig = useSelector(state => state.adminPanel.selectedConfig);
  // console.log("selectedConfigValue:",selectedConfigValue);
  const [configOptions, setConfigOptions] = useState([]);
  const [configSelect, setConfigSelect] = useState("");
  // console.log("configSelect:",configSelect);
  // const initialText = JSON.stringify(
  //   omit(config, ["_id", "createdAt", "updatedAt", "__v", "configType"]),
  //   undefined,
  //   4
  // );
  const [restored, setRestored] = useState(true);
  const [open, setOpen] = useState(false);
  const [openSave, setOpenSave] = useState(false);
  const [edit, setEdit] = useState(false);
  const [text, setText] = useState("");
  const [initialText, setInitialText] = useState("");
  const [hintJSON, setHintJSON] = useState("");
  const [error, setError] = useState("");
  const [msg, setMsg] = useState();

  const checkJSONStructure = str => {
    try {
      JSON.parse(str);
      setHintJSON("");
    } catch (e) {
      setHintJSON(e.name + ": " + e.message);
      return false;
    }
    return true;
  };
  const prettify = value => {
    try {
      if (checkJSONStructure(value)) {
        setHintJSON("");
        const ugly = JSON.parse(value);
        const pretty = JSON.stringify(ugly, undefined, 4);
        return pretty;
      }
    } catch (err) {
      console.log(err);
      setHintJSON(err);
    }
    return value;
  };
  const handleSave = () => {
    const code = selectedConfig.code;
    const parsedValue = JSON.parse(text);
    const value = JSON.stringify(parsedValue);
    const type = selectedConfig.type;
    dispatch(updateAppConfig(code, value, type));
    setInitialText(text);
    setEdit(false);
  }
  const handleRestore = () => {
    restoreConfig(selectedConfig.code);
    setRestored(true);
  }

  useEffect(() => {
    dispatch(getAllAppConfigurations());
  }, []);
  // console.log("ALL CONFIGS:",allConfigs);
  useEffect(()=>{
    if(allConfigs){
      const tempArray = allConfigs.map(item=>item.code);
      setConfigOptions(tempArray.sort());
    }
  }, [allConfigs]);
  // console.log("ALL CONFIGS OPTIONS:",configOptions);
  useEffect(()=>{
    if(configSelect){
      dispatch(getSelectedAppConfiguration(configSelect));
      setRestored(false);
    }
  }, [configSelect,restored]);
  useEffect(() => {
    if (text !== initialText) {
      setMsg("Unsaved changes");
      setOpenSave(false);
    } else {
        setMsg("");
        setOpenSave(true);
      }
  }, [text, initialText]);
  useEffect(() => {
    if (selectedConfigValue) {
      setText(prettify(selectedConfigValue));
      setInitialText(prettify(selectedConfigValue));
    }
  }, [selectedConfigValue]);
  useEffect(()=>{
    if (!configSelect) {
      setText("");
      setInitialText("");
    }
  },[configSelect]);

  return (
    <>
      <div id="config-page">
        <div id="config-control">
        <Select 
          value={configSelect || null}
          placeholder='Select Configuration'
          className="select-config-option"
          allowClear={true}
          options={configOptions.map(item => ({
            label: item,
            value: item
          }))}
          onChange={event=>setConfigSelect(event)}
        />
          <Button disabled={text ? false : true} onClick={() => setEdit(true)}>Edit</Button>
          <Button disabled={text ? false : true} onClick={() => setText(prettify(text))}>Prettify</Button>
          <Button
            disabled={!edit}
            onClick={() => {
              setEdit(false);
              setText(initialText);
            //   dispatchito(clearConfigError());
            }}
          >
            Cancel
          </Button>
          <Button
            disabled={openSave}
            onClick={() => {
              if (checkJSONStructure(text)) {
                handleSave();
              } else {
                setMsg("Can't save JSON that is not valid");
              }
            }}
          >
            Save
          </Button>
          <Button
            disabled={text ? false : true}
            onClick={async () => {
                setEdit(false);
                setOpen(true);
            }}
          >
            Restore
          </Button>
          <Typography.Text type="warning">{msg}</Typography.Text>
          <Typography.Text type="danger">{configError}</Typography.Text>
          <Typography.Text type="danger">{hintJSON}</Typography.Text>
        </div>
        <Input.TextArea
          id="config-json-textarea"
          // cols={100}
          // rows={20}
          status={error ? "error" : ""}
          disabled={!edit}
          value={text}
          onChange={e => {
            setText(e.target.value);
          }}
        />
      </div>
      <Modal
        title={<h1 style={{color:"#dc2f2f", marginTop:"0.563rem", marginLeft:"1rem"}}>Warning!</h1>}
        open={open}
        Icon={WarningRed}
        centered
        width={450}
        onOk={() => {
          setOpen(false);
          handleRestore();
        }}
        onCancel={() => setOpen(false)}
        okText="Confirm"
        cancelText="Cancel"
      >
        <p>
          You are about to restore the configuration to factory settings and all
          changes will be lost.
        </p>
        <p>Are you sure you wish to continue?</p>
      </Modal>
    </>
  );
};

export default Templates;